import { useRef } from "react";
import { useSelector } from "react-redux";
import { useThree } from "@react-three/fiber";
import { PerspectiveCamera } from "@react-three/drei";
import { degToRad } from "three/src/math/MathUtils.js";
import { forwardRef, useImperativeHandle } from "react";

const CaptureCamera = forwardRef((props, ref) => {
    const cameraRef = useRef();
    const { gl, scene } = useThree();

    const model = useSelector((state) => state.roomData.model);

    const isMobile = () => {
        const minWidth = 720; // Minimum width for desktop devices
        return window.innerWidth < minWidth || screen.width < minWidth;
    };

    const getImage = () => {
        cameraRef.current.zoom = model == "Suite" || model == "Suite Plus" || model == "Suite Doble" ? 1.2 : 0.8;
        if (isMobile()) {cameraRef.current.zoom = cameraRef.current.zoom * 0.75;}
        cameraRef.current.updateProjectionMatrix();
        gl.render(scene, cameraRef.current);
        const image = gl.domElement.toDataURL("image/png");
        return image;
    };

    useImperativeHandle(ref, () => ({ getImage }));

    return (
        <PerspectiveCamera
            ref={cameraRef}
            fov={45}
            near={0.1}
            far={2000}
            zoom={0.8}
            position={[-1.5, 1.65, 4.8]}
            rotation={[degToRad(-20), degToRad(-17), degToRad(-5)]}
        />
    );
});

export default CaptureCamera;
